import { EnumGoodsDetailIsSpike } from '../../../lib/webx/defines'
import { is } from '@didi/webx-js'
const addHook = (hooks, key, fn) => {
  if (!hooks[key]) {
    hooks[key] = fn
  } else if (Array.isArray(hooks[key])) {
    hooks[key].unshift(fn)
  } else {
    hooks[key] = [fn, hooks[key]]
  }
}

export const BogoMixin = PageConfig => {
  addHook(PageConfig.hooks, 'afterOrder', function ({ errno, orderId }) {
    if (__mpx_mode__ === 'web' && is('miniprogram')) return
    const component = this.MallRenderData.components.find(
      component => component.name === 'pay-result'
    )
    if (component) {
      component.data.isBogo =
        this.$data.$_.goods.isSpike === EnumGoodsDetailIsSpike.Bogo
    }
  })

  return {}
}
